import * as Global from "styles/global/global.styles";

export function Container() {
  return {
    zIndex: Global.zIndex().foreground,
    display: "grid",
    placeItems: "center",
    m: "0",
    p: "0",
    height: Global.viewport().height,
  };
}

export function Card() {
  return {
    height: "100%",
    borderRadius: "30px",
    px: "2rem",
    py: "2rem",
    m: "0",
    maxHeight: "400px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    width: "100%",
    // flexBasis: 'auto',
  };
}

export function Title() {
  return {
    textAlign: "center",
    // textTransform: 'uppercase',
    color: Global.colors().headers,
  };
}

export function Subtitle() {
  return {
    textAlign: "center",
  };
}

export function Button() {
  return {
    border: `1px solid ${Global.colors().__itsme.default}`,
    backgroundColor: Global.colors().__itsme.default,
    borderRadius: "10px",
    height: "70px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    px: "2rem",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: Global.colors().__itsme.hover,
    },
  };
}

export function ButtonBpolb() {
  return {
    border: `1px solid ${Global.colors().headers}`,
    backgroundColor: Global.colors().headers,
    borderRadius: "10px",
    height: "70px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
    px: "2rem",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#243781",
    },
  };
}

export function BpolbText() {
  return {
    fontFamily: Global.fonts().robotoSlab,
    color: "#fff",
    fontSize: { xs: "unset", sm: "20px" },
    fontWeight: "bold",
    gap: ".2rem",
    textAlign: "center",
  };
}
